//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconActionShareFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M18 10C20.2091 10 22 8.20914 22 6C22 3.79086 20.2091 2 18 2C15.7909 2 14 3.79086 14 6C14 8.20914 15.7909 10 18 10Z" fill="currentColor" /><path d="M18 14C16.8 14 15.73 14.54 15 15.38L11.37 13.56L10.48 15.35L14.1 17.16C13.51 19.86 15.67 22 18 22C20.21 22 22 20.21 22 18C22 15.79 20.21 14 18 14Z" fill="currentColor" /><path d="M13.52 9.36001L12.63 7.57001L9 9.38001C8.27 8.54001 7.2 8.00001 6 8.00001C3.79 8.00001 2 9.79001 2 12C2 14.21 3.79 16 6 16C8.73 16 10.4 13.48 9.91 11.16L13.52 9.36001Z" fill="currentColor" /></svg>;
}
export default IconActionShareFill;